<template>
  <div id="page-claim-details">
    <commercial-claim-form
        v-model="model"
        :loading="loading"
        ref="form"
        @add-dynamic-claim="addDynamicClaim"
        card-title="Edit"
    />
    <div class="vx-row">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button
              @click="$router.push({ name: 'commercial-claims.view', params: { id } })"
              class="my-4"
          >
            Cancel
          </vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
              @click="save"
              class="my-4"
              color="light"
              :disabled="!model.id"
          >
            Save
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import CommercialClaimForm from "@/views/pages/commercial-claims/CommercialClaimForm";
import ViewModelMixin from "@/components/mixins/ViewModelMixin";
import NotificationMixin from "@/components/mixins/NotificationMixin";
import SaveModelMixin from '@/components/mixins/SaveModelMixin';

export default {
  name: "CommercialClaimEdit",
  components: {
    CommercialClaimForm,
  },
  mixins: [ViewModelMixin,NotificationMixin,SaveModelMixin],
  data() {
    return {
      modelEntity: this.$api.commercialClaims,
      entity: 'Commercial Claim',
      references: [
        'ProductCategory_RiskCode_FK',
        'ProductCategory_SubRiskCode_FK',
        'SalesCountryType_FK',
      ],
    };
  },
  computed: {
    title() {
      if (!this.model.CommercialClaimName) {
        return '';
      }

      const name = this.model.CommercialClaimName  || '';
      return '<h1>Commercial Claim: ' + name + '</h1>';
    }
  },
  methods: {
    addDynamicClaim(value) {
      this.references.push(value);
    },
  },
};
</script>

<style scoped>

</style>
